<template>
  <Card class="account-extension" bordered :type="cardStatus">
    <template v-if="membershipInfo.isExpired">
      <ExpiredAccount :loading="isProcessing" @extend="extendMembership" />
    </template>

    <template v-else>
      <ActiveAccount
        :expiration-date="expirationDate"
        :can-extend="membershipInfo.canExtend"
        :loading="isProcessing"
        @extend="extendMembership"
      />
    </template>
  </Card>
</template>

<script>
import { MEMBERSHIP, LANGUAGE } from '@/store/types';
import { Membership } from '@/api/api';
import redirectViaForm from '@/utils/redirectViaForm';
import Card from '@@/common/Card';
import ExpiredAccount from './ExpiredAccount';
import ActiveAccount from './ActiveAccount';
import { mapActions } from 'vuex';

export default {
  name: 'AccountExtension',
  components: {
    Card,
    ExpiredAccount,
    ActiveAccount,
  },
  data() {
    return {
      isProcessing: false,
    };
  },
  computed: {
    lang() {
      return this.$store.getters[LANGUAGE];
    },
    membershipInfo() {
      return this.$store.getters[MEMBERSHIP];
    },
    expirationDate() {
      const { expireDate } = this.membershipInfo;
      return this.$d(new Date(expireDate), 'short', this.lang);
    },
    cardStatus() {
      return this.membershipInfo.isExpired ? 'danger' : 'success';
    },
  },
  created() {
    if (this.$route.hash === '#callback') {
      this.extendMembership();
    }
  },
  methods: {
    extendMembership() {
      this.isProcessing = true;
      return Membership.extend()
        .then(
          ({
            body: {
              link_to_bank_gateway: redirectUrl,
              ref_token: RefId,
              message,
              expire_date,
            },
          }) => {
            if (redirectUrl && RefId) {
              this.$message.success(this.$t('REDIRECTING_TO_BANK_GATEWAY'));
              // Send pay request to the bank gateway
              redirectViaForm(redirectUrl, { RefId });
            } else if (expire_date) {
              this.$message.success(message);
              this.setMembershipInfo({
                ...this.membershipInfo,
                expireDate: expire_date,
                isExpired: false,
                canExtend: false,
              });
            }
          },
        )
        .catch(({ body: { message } = {} }) => {
          if (message) {
            this.$message.error(message);
          }
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
    ...mapActions({
      setMembershipInfo: MEMBERSHIP,
    }),
  },
};
</script>

<style lang="scss">
.account-extension {
  &__state {
    &--active {
      color: $lb-color-success;
    }

    &--extendable {
      margin-bottom: $global-margin / 2;
    }
  }

  &__expire-date {
    color: $lb-black;
  }
}
</style>
